// Daily Discussion Topics for Community Chat
// Organized by trimester AND role for maximum relevance
// Topics rotate daily, consistent per cohort, role-specific

// ============ PREGNANT PERSON TOPICS ============

export const PREGNANT_TOPICS_FIRST_TRIMESTER: string[] = [
    // Weeks 1-12: Early pregnancy, symptoms, sharing news
    "What was your reaction when you first saw that positive test?",
    "How have you been managing morning sickness?",
    "What food aversions have surprised you the most?",
    "Have you told anyone yet? How did it go?",
    "What's the hardest part about keeping the secret?",
    "How are you feeling about your changing body so far?",
    "What symptoms caught you completely off guard?",
    "How are you managing fatigue in the first trimester?",
    "What's one thing that's helped with nausea?",
    "How do you feel about your first ultrasound coming up?",
    "What foods are you actually able to eat right now?",
    "How are you dealing with the emotional ups and downs?",
    "What's your biggest worry at this stage?",
    "How are you staying comfortable at work?",
    "What's been the most unexpected part of early pregnancy?",
    "How are you handling heightened sense of smell?",
    "What cravings have kicked in already?",
    "How supported do you feel right now?",
    "What's one thing you wish people understood about this stage?",
    "How are you taking care of yourself today?",
    "What questions do you have for your first appointment?",
    "How are you feeling about becoming a mother?",
    "What's keeping you going on the hard days?",
    "How do you plan to announce the pregnancy?",
    "What's one thing that made you smile this week?",
    "How are you managing work while feeling unwell?",
    "What's your go-to comfort activity right now?",
    "How are you sleeping these days?",
    "What's the most helpful thing someone has done for you?",
    "How are you feeling emotionally today?",
    "What's something you're looking forward to in the second trimester?",
    "How are you dealing with bloating and discomfort?",
    "What prenatal vitamins are you taking?",
    "How do you manage anxiety about miscarriage?",
    "What's one thing you want to remember about this time?",
    // Additional topics for full trimester coverage
    "How are you managing headaches in early pregnancy?",
    "What's your experience with pregnancy mood swings?",
    "How has your relationship with food changed?",
    "What's helping you through the waiting periods?",
    "How do you feel about sharing news with coworkers?",
    "What's your strategy for dealing with exhaustion?",
    "How are you staying hydrated when nothing sounds good?",
    "What small wins have you celebrated this week?",
    "How are you managing stress during the first trimester?",
    "What's been your partner's most supportive moment?",
    "How are you handling the unpredictability of symptoms?",
    "What's one pregnancy myth you've learned is false?",
    "How do you feel about the timeline of pregnancy announcements?",
    "What's helping you feel more connected to the pregnancy?",
    "How are you balancing rest with daily responsibilities?",
    "What's one thing that's been harder than expected?",
    "How are you preparing for the anatomy scan?",
    "What questions keep running through your mind?",
    "How do you feel about genetic testing options?",
    "What's your experience with food aversions vs cravings?",
    "How are you managing constipation and digestive issues?",
    "What's helping you stay positive?",
    "How are you dealing with breast tenderness?",
    "What resources have been most helpful so far?",
    "How do you feel about your growing sense of parenthood?",
    "What's one thing you've stopped doing since finding out?",
    "How are you processing fears about the unknown?",
    "What's your experience with early pregnancy spotting concerns?",
    "How are you staying active despite the fatigue?",
    "What's one thing you're grateful for today?",
    "How do you feel about the changes to your wardrobe already?",
    "What's your experience with vivid pregnancy dreams?",
    "How are you managing work deadlines while exhausted?",
    "What's helping you feel more prepared?",
    "How are you dealing with heightened emotions?",
    "What's one thing you've learned to ask for help with?",
    "How are you feeling about your healthcare provider so far?",
    "What's your strategy for getting through long days?",
    "How are you maintaining your mental health?",
    "What's one thing you're excited to tell your child about this time?",
    "How do you feel about the waiting game until the next ultrasound?",
    "What's been your most unexpected emotion this week?",
    "How are you preparing for the transition to maternity clothes?",
    "What's helping you feel connected to other pregnant people?",
    "How are you managing the urge to tell everyone?",
    "What's one boundary you've set that's been helpful?",
    "How do you feel about tracking pregnancy milestones?",
    "What's your experience with first trimester insomnia?",
    "How are you processing the reality of becoming a parent?",
    "What's one thing you'd tell yourself at the start of pregnancy?",
    "How are you staying connected to your identity outside of pregnancy?",
];

export const PREGNANT_TOPICS_SECOND_TRIMESTER: string[] = [
    // Weeks 13-27: Baby moving, gender reveals, growing bump
    "When did you first feel the baby move, and what was it like?",
    "How are you feeling about your growing bump?",
    "Did you find out the gender? How do you feel about it?",
    "What baby names are at the top of your list?",
    "How has your energy changed since the first trimester?",
    "What's the most exciting part of this stage for you?",
    "How are maternity clothes treating you?",
    "What's your bump measuring at, and how do you feel about it?",
    "How are you staying active during pregnancy?",
    "What's on your baby registry so far?",
    "How are you preparing the nursery?",
    "What's the cutest item you've gotten for baby?",
    "How are you feeling about labor and delivery?",
    "What childbirth class are you considering?",
    "How has your appetite changed?",
    "What's your favorite thing about being pregnant right now?",
    "How are you bonding with the baby bump?",
    "What's something that surprised you this trimester?",
    "How are you handling unsolicited pregnancy advice?",
    "What's your plan for announcing the gender (if applicable)?",
    "How are you managing work as your bump grows?",
    "What's your favorite way to feel the baby move?",
    "How are you staying comfortable sleeping?",
    "What's one thing you're really excited to buy for baby?",
    "How are you feeling about your body image right now?",
    "What's your current biggest craving?",
    "How is your relationship with your partner evolving?",
    "What prenatal appointment are you looking forward to?",
    "How are you handling round ligament pain?",
    "What's one piece of advice you'd give to first-trimester moms?",
    "How are you celebrating this pregnancy milestone?",
    "What's the hardest part of the second trimester for you?",
    "How are you preparing emotionally for motherhood?",
    "What's your birth plan looking like so far?",
    "How are you managing pregnancy brain?",
    // Additional topics for full trimester coverage
    "What's your experience with the anatomy scan?",
    "How do you feel about sharing bump photos?",
    "What's the most surprising thing about baby's movements?",
    "How are you handling back pain during pregnancy?",
    "What's your favorite pregnancy-safe exercise?",
    "How are you dealing with leg cramps at night?",
    "What's one thing you've splurged on for baby?",
    "How do you feel about your changing wardrobe?",
    "What's helping you feel beautiful during pregnancy?",
    "How are you handling comments about your bump size?",
    "What's your experience with pregnancy hormones?",
    "How are you preparing for the glucose test?",
    "What's your strategy for staying organized?",
    "How do you feel about your baby's name choices?",
    "What's the most helpful pregnancy app you use?",
    "How are you staying connected with friends during pregnancy?",
    "What's your go-to pregnancy snack?",
    "How are you handling hip pain while sleeping?",
    "What's one thing you're nervous about for the third trimester?",
    "How do you feel about breastfeeding vs formula?",
    "What's your experience with pregnancy skin changes?",
    "How are you preparing for maternity photos?",
    "What's the best pregnancy advice you've received?",
    "How do you feel about baby showers?",
    "What's your strategy for dealing with heartburn?",
    "How are you staying cool during pregnancy?",
    "What's one thing you want to do before baby arrives?",
    "How are you handling anxiety about becoming a parent?",
    "What's your favorite thing about your bump?",
    "How do you feel about your birthing location choice?",
    "What's helping you stay patient during pregnancy?",
    "How are you managing work-life balance?",
    "What's your plan for announcing baby's birth?",
    "How do you feel about your healthcare team?",
    "What's your experience with nesting instincts early?",
    "How are you handling sweets cravings?",
    "What's one thing that's different than you expected?",
    "How are you preparing siblings or pets for baby?",
    "What's your strategy for remembering things with pregnancy brain?",
    "How do you feel about your labor and delivery preferences?",
    "What's the most supportive thing your partner has done?",
    "How are you handling mood changes this trimester?",
    "What's your experience with fetal hiccups?",
    "How do you feel about your weight gain so far?",
    "What's helping you embrace body changes?",
    "How are you preparing for nighttime feedings?",
    "What's your plan for postpartum recovery?",
    "How do you feel about epidural options?",
    "What's one fear you've overcome this trimester?",
    "How are you handling increased bathroom trips?",
    "What's your strategy for staying hydrated?",
    "How do you feel about your due date month?",
    "What's the most special moment of this trimester?",
    "How are you documenting your pregnancy journey?",
    "What's your experience with prenatal yoga or exercise?",
    "How do you feel about cord blood banking?",
    "What's helping you stay positive about birth?",
    "How are you handling pressure from family about choices?",
    "What's one thing you wish you knew about the second trimester?",
    "How do you feel about your nursery progress?",
    "What's your strategy for managing expectations?",
    "How are you planning your parental leave?",
    "What's the sweetest thing someone has done for you?",
    "How do you feel about your baby's gender (or surprise)?",
    "What's helping you bond with baby before birth?",
    "How are you handling questions about your pregnancy?",
    "What's your experience with finding comfortable positions?",
    "How do you feel about your registry choices?",
    "What's one tradition you want to start with your family?",
    "How are you preparing mentally for birth?",
    "What's the best part of the second trimester for you?",
];

export const PREGNANT_TOPICS_THIRD_TRIMESTER: string[] = [
    // Weeks 28-40+: Final stretch, labor prep, nesting
    "How are you handling the discomfort of the third trimester?",
    "What's packed in your hospital bag so far?",
    "How are you feeling as the due date approaches?",
    "What are you most nervous about for labor?",
    "How are you managing sleep in the third trimester?",
    "What nesting projects have you been working on?",
    "How are you staying patient as you wait?",
    "What's your labor and delivery plan?",
    "How are you preparing for the first week home?",
    "What Braxton Hicks experiences have you had?",
    "How are you managing swelling and discomfort?",
    "What's helping you stay comfortable?",
    "How do you feel about your baby shower?",
    "What's the one thing you still need to do before baby arrives?",
    "How are you mentally preparing for birth?",
    "What affirmations are you using for labor?",
    "How are you spending your last days/weeks before baby?",
    "What's your postpartum plan?",
    "How are you dealing with the 'any day now' anticipation?",
    "What signs of labor are you watching for?",
    "How are you handling the emotional weight of this stage?",
    "What's your biggest hope for your birth experience?",
    "How are you staying connected with your partner?",
    "What comfort measures are you planning for labor?",
    "How are you feeling about breastfeeding?",
    "What would make you feel more ready for baby?",
    "How are you managing last-minute preparations?",
    "What's one thing you want to tell your future self about this time?",
    "How are you coping with the physical demands of late pregnancy?",
    "What's your plan for immediate postpartum recovery?",
    "How are you feeling about your body carrying this baby?",
    "What's something you're proud of in this pregnancy journey?",
    "How are you preparing older children or pets for baby?",
    "What's keeping you going in these final weeks?",
    "How will you celebrate finally meeting your baby?",
    // Additional topics for full trimester coverage
    "What's your strategy for dealing with shortness of breath?",
    "How are you handling the pressure on your bladder?",
    "What's your experience with lightning crotch pain?",
    "How do you feel about your baby's position?",
    "What's helping you relax before labor?",
    "How are you managing anxiety about birth?",
    "What's your plan for labor support people?",
    "How do you feel about induction if needed?",
    "What's your strategy for managing contractions?",
    "How are you preparing for skin-to-skin?",
    "What's your experience with the non-stress test?",
    "How do you feel about delayed cord clamping?",
    "What's helping you stay mobile despite discomfort?",
    "How are you handling the final stretch at work?",
    "What's your strategy for when labor starts?",
    "How do you feel about your support team for birth?",
    "What's your experience with baby dropping?",
    "How are you managing pelvic pressure?",
    "What's helping you find comfortable positions?",
    "How do you feel about labor interventions?",
    "What's your plan for communicating during labor?",
    "How are you preparing for recovery after birth?",
    "What's your experience with stretch marks this trimester?",
    "How do you feel about your readiness for baby?",
    "What's helping you embrace the final weeks?",
    "How are you managing carpal tunnel from pregnancy?",
    "What's your plan for visitors after birth?",
    "How do you feel about your hospital or birth center?",
    "What's your experience with the bump measuring?",
    "How are you handling unsolicited birth stories?",
    "What's your strategy for staying calm if overdue?",
    "How do you feel about membrane sweep options?",
    "What's helping you physically prepare for labor?",
    "How are you managing heartburn in the third trimester?",
    "What's your plan for feeding baby in the first days?",
    "How do you feel about your pediatrician choice?",
    "What's your experience with nesting energy?",
    "How are you preparing your bedroom for baby?",
    "What's helping you manage back labor concerns?",
    "How do you feel about water birth options?",
    "What's your strategy for handling prodromal labor?",
    "How are you preparing for the emotional birth experience?",
    "What's your plan for birth photography or video?",
    "How do you feel about your placenta plans?",
    "What's helping you trust your birth instincts?",
    "How are you managing the 'any day now' texts?",
    "What's your experience with the Group B strep test?",
    "How do you feel about your baby's due date accuracy?",
    "What's your plan for labor playlist or ambiance?",
    "How are you preparing for the golden hour?",
    "What's helping you feel empowered for birth?",
    "How do you feel about your postpartum meal prep?",
    "What's your strategy for managing fear of the unknown?",
    "How are you preparing for life with a newborn?",
    "What's your experience with late pregnancy insomnia?",
    "How do you feel about your birth team's support?",
    "What's one thing keeping you grounded right now?",
    "How are you celebrating your final weeks of pregnancy?",
];

// ============ PARTNER TOPICS ============

export const PARTNER_TOPICS_FIRST_TRIMESTER: string[] = [
    // Weeks 1-12: Supporting through symptoms, processing news
    "How did you react when you found out you were going to be a parent?",
    "What's the best way you've supported your partner through morning sickness?",
    "How are you processing the news of becoming a parent?",
    "What's something you've done to make your partner's day easier?",
    "How are you handling the secrecy of early pregnancy?",
    "What fears or worries are you experiencing?",
    "How connected do you feel to the pregnancy right now?",
    "What's the most surprising thing about this early stage?",
    "How are you preparing yourself emotionally for fatherhood/parenthood?",
    "What's one thing you've learned about pregnancy you didn't know before?",
    "How are you adjusting your lifestyle for the pregnancy?",
    "What's the hardest part of watching your partner go through this?",
    "How are you handling your own emotions about becoming a parent?",
    "What's one way you've shown up for your partner this week?",
    "How do you imagine life will change when baby arrives?",
    "What questions do you have about pregnancy and birth?",
    "How are you and your partner communicating differently now?",
    "What's one thing you're really excited about?",
    "How are you managing work-life balance with pregnancy responsibilities?",
    "What kind of parent do you hope to be?",
    "How are you supporting your partner's physical needs?",
    "What's one thing that's made you feel more connected to the baby?",
    "How are you preparing for the first ultrasound?",
    "What's your biggest concern right now?",
    "How are you taking care of yourself during this time?",
    "What's a way you've celebrated the pregnancy so far?",
    "How are you and your partner making decisions together?",
    "What's one thing you want to learn before baby comes?",
    "How are you handling the uncertainty of early pregnancy?",
    "What's been the most meaningful moment so far?",
    "How are you supporting your partner emotionally?",
    "What's one thing you appreciate about your partner?",
    "How are you staying informed about pregnancy?",
    "What's your reaction to the body changes your partner is experiencing?",
    "How do you feel about telling family and friends?",
    // Additional topics for full trimester coverage
    "What's helping you feel more prepared each day?",
    "How are you managing stress about becoming a parent?",
    "What resources have you found helpful for partners?",
    "How do you feel about your partner's healthcare choices?",
    "What's your experience with prenatal appointments so far?",
    "How are you handling dietary changes at home?",
    "What's one thing you've given up to support the pregnancy?",
    "How do you feel about your changing roles at home?",
    "What's helping you bond with your partner during this time?",
    "How are you preparing financially for a baby?",
    "What conversations have been hardest to have?",
    "How do you feel about genetic testing decisions?",
    "What's your strategy for being more helpful at home?",
    "How are you dealing with your partner's mood changes?",
    "What's one thing you're secretly worried about?",
    "How do you feel about the timeline of sharing news?",
    "What's helping you feel connected to the pregnancy?",
    "How are you managing your own health during this time?",
    "What's one thing you've learned about your relationship?",
    "How do you feel about the first ultrasound experience?",
    "What's your plan for supporting during appointments?",
    "How are you handling excitement vs anxiety?",
    "What's one thing you want to change before baby comes?",
    "How do you feel about parenting philosophies?",
    "What resources are you using to learn about babies?",
    "How are you preparing for the second trimester changes?",
    "What's your experience with keeping the secret?",
    "How do you feel about your partner's symptoms?",
    "What's one thing you've done to surprise your partner?",
    "How are you handling questions from family?",
    "What's your strategy for being emotionally available?",
    "How do you feel about announcing the pregnancy?",
    "What's one conversation you need to have with your partner?",
    "How are you managing sleep when your partner can't sleep?",
    "What's helping you process becoming a parent?",
    "How do you feel about your support network?",
    "What's one thing you've done to prepare the home?",
    "How are you handling the waiting between appointments?",
    "What's your experience with pregnancy books or resources?",
    "How do you feel about your relationship changes?",
    "What's one tradition you want to start now?",
    "How are you supporting your partner's work situation?",
    "What's challenging about this stage for you personally?",
    "How do you feel about the first trimester timeline?",
    "What's helping you manage your own emotions?",
    "How are you preparing for lifestyle changes?",
    "What's one thing you're grateful for right now?",
    "How do you feel about your communication with your partner?",
    "What's your reaction to pregnancy milestones?",
    "How are you staying connected to your own interests?",
    "What's one fear you've been able to let go of?",
    "How do you feel about your role in this pregnancy journey?",
];

export const PARTNER_TOPICS_SECOND_TRIMESTER: string[] = [
    // Weeks 13-27: Feeling baby move, preparing together
    "What was it like the first time you felt the baby move?",
    "How are you helping prepare the nursery?",
    "What baby items are you most excited to use?",
    "How are you bonding with the baby before birth?",
    "What's your reaction to the growing bump?",
    "How are you and your partner discussing baby names?",
    "What's one thing you've done to prepare for parenthood?",
    "How are you feeling about the gender (if you found out)?",
    "What's been your favorite moment of the second trimester?",
    "How are you supporting your partner as the bump grows?",
    "What's one thing you've learned about your partner during pregnancy?",
    "How are you preparing financially for baby?",
    "What parenting topics have you and your partner discussed?",
    "How do you feel about childbirth classes?",
    "What's your role in the birth plan?",
    "How are you staying connected with your partner?",
    "What's one thing you're nervous about?",
    "How are you preparing the home for baby?",
    "What's a date night you've had during pregnancy?",
    "How are you managing your partner's changing needs?",
    "What's something sweet you've done for your partner recently?",
    "How do you envision your family's future?",
    "What's your plan for paternity/parental leave?",
    "How are you feeling about becoming a parent of a [boy/girl/surprise]?",
    "What traditions do you want to start with your family?",
    "How are you helping with pregnancy discomfort?",
    "What's something that's made you feel like a parent already?",
    "How are you preparing emotionally for the baby?",
    "What's one thing you appreciate about this journey?",
    "How are you managing expectations about parenting?",
    "What's your communication style with your partner about baby things?",
    "How are you handling friends and family advice?",
    "What's one thing you want your child to know about this time?",
    "How are you supporting your partner's body image?",
    "What's making you most excited about being a parent?",
    // Additional topics for full trimester coverage
    "How do you feel about attending the anatomy scan?",
    "What's your experience with talking to the baby bump?",
    "How are you handling the reality of baby preparations?",
    "What's one thing you've built or assembled for baby?",
    "How do you feel about your partner's pregnancy glow?",
    "What's your plan for helping with registry research?",
    "How are you supporting your partner's exercise routine?",
    "What's one moment that made parenthood feel real?",
    "How do you feel about learning baby care skills?",
    "What's your strategy for being present during this trimester?",
    "How are you handling the transition to thinking like a parent?",
    "What's one thing you've bought that you're excited about?",
    "How do you feel about your involvement in baby prep?",
    "What's your plan for the baby shower?",
    "How are you staying patient with the waiting?",
    "What's one fear you've worked through this trimester?",
    "How do you feel about your partner's needs changing?",
    "What's helping you feel ready for the third trimester?",
    "How are you handling the midpoint of pregnancy?",
    "What's one thing you've done to show appreciation?",
    "How do you feel about childcare decisions?",
    "What's your plan for supporting breastfeeding?",
    "How are you learning about newborn care?",
    "What's one thing that surprised you this trimester?",
    "How do you feel about your evolving relationship?",
    "What's your strategy for managing home responsibilities?",
    "How are you preparing mentally for sleepless nights?",
    "What's one tradition from your childhood you want to share?",
    "How do you feel about your partner's birth preferences?",
    "What's your plan for being the best support person?",
    "How are you handling different parenting opinions?",
    "What's one thing you're learning about babies?",
    "How do you feel about your nursery progress?",
    "What's your strategy for maintaining your relationship?",
    "How are you supporting your partner's work situation?",
    "What's one thing you want to teach your child?",
    "How do you feel about becoming a role model?",
    "What's your plan for managing stress before baby?",
    "How are you dealing with advice from other parents?",
    "What's one thing you want to document about this time?",
    "How do you feel about your readiness for baby?",
    "What's helping you stay excited during the wait?",
    "How are you supporting your partner's mental health?",
    "What's one skill you want to learn before baby comes?",
    "How do you feel about baby-proofing the home?",
    "What's your strategy for the final trimester prep?",
    "How are you handling the emotional rollercoaster?",
    "What's one thing you've done to connect with other parents?",
    "How do you feel about your co-parenting partnership?",
    "What's your plan for balancing work and new parenthood?",
    "How are you staying present in daily moments?",
    "What's one thing you're grateful for this week?",
    "How do you feel about the upcoming birth experience?",
    "What's helping you feel like a team with your partner?",
    "How are you preparing for the emotional impact of birth?",
    "What's one way you've grown during this pregnancy?",
];

export const PARTNER_TOPICS_THIRD_TRIMESTER: string[] = [
    // Weeks 28-40+: Final prep, labor support, ready for baby
    "How are you feeling as the due date gets closer?",
    "What's your role in the labor and delivery plan?",
    "How are you preparing to support your partner during birth?",
    "What's packed in your bag for the hospital?",
    "How are you managing the anticipation of baby's arrival?",
    "What comfort techniques are you learning for labor support?",
    "How are you helping with final preparations?",
    "What's one thing you're doing to be ready for baby?",
    "How are you feeling about witnessing the birth?",
    "What's your plan for the first week home with baby?",
    "How are you supporting your partner through third trimester discomfort?",
    "What's one thing you want to tell your partner before baby comes?",
    "How are you preparing the car and car seat?",
    "What's your biggest hope for the birth experience?",
    "How are you staying calm as the due date approaches?",
    "What's one way you'll support your partner postpartum?",
    "How are you mentally preparing to meet your baby?",
    "What questions do you have about labor and delivery?",
    "How are you and your partner staying connected in these final weeks?",
    "What's the most helpful thing you've done recently?",
    "How are you preparing for sleepless nights?",
    "What's one thing you're really looking forward to after birth?",
    "How are you feeling about feeding and diaper changes?",
    "What's your postpartum support plan for your partner?",
    "How are you celebrating this final stretch together?",
    "What's one thing you want to remember about this time?",
    "How are you handling the 'any moment now' energy?",
    "What's your plan if labor starts suddenly?",
    "How are you feeling about your relationship after baby?",
    "What's one affirmation you're holding onto?",
    "How are you taking care of your own mental health?",
    "What's making you feel ready to be a parent?",
    "How are you helping your partner stay comfortable?",
    "What music or playlist are you preparing for labor?",
    "How will you announce baby's arrival?",
    // Additional topics for full trimester coverage
    "What's your plan for managing visitors after birth?",
    "How do you feel about your readiness as a labor coach?",
    "What's one thing you've practiced for labor support?",
    "How are you handling your own nervousness about birth?",
    "What's your strategy for staying awake during labor?",
    "How do you feel about different birth scenarios?",
    "What's your plan for keeping your partner calm?",
    "How are you preparing for skin-to-skin bonding?",
    "What's one thing you want to say when baby arrives?",
    "How do you feel about cutting the cord?",
    "What's your plan for documenting the birth?",
    "How are you preparing for the hospital stay?",
    "What's one thing you're nervous about postpartum?",
    "How do you feel about your paternity/parental leave plan?",
    "What's your strategy for managing work before leave?",
    "How are you preparing meals for after baby comes?",
    "What's one thing you've done to prepare emotionally?",
    "How do you feel about your baby gear knowledge?",
    "What's your plan for the drive to the hospital?",
    "How are you handling the waiting game?",
    "What's one thing you've learned from other dads/partners?",
    "How do you feel about your ability to help with feeding?",
    "What's your strategy for supporting your partner's recovery?",
    "How are you preparing for the emotional birth experience?",
    "What's one thing you're doing to stay healthy before baby?",
    "How do you feel about your communication with your partner?",
    "What's your plan for the first diaper change?",
    "How are you handling anxiety about becoming a parent?",
    "What's one thing keeping you grounded right now?",
    "How do you feel about your support network?",
    "What's your strategy for staying positive?",
    "How are you preparing for postpartum challenges?",
    "What's one thing you want to do differently than your parents?",
    "How do you feel about your co-parenting communication?",
    "What's your plan for bonding time with baby?",
    "How are you handling the anticipation of meeting your child?",
    "What's one thing you've learned about newborns?",
    "How do you feel about night feeding shifts?",
    "What's your strategy for supporting breastfeeding?",
    "How are you preparing for the fourth trimester?",
    "What's one thing you're proud of in your preparation?",
    "How do you feel about your baby's nursery?",
    "What's your plan for the first few days home?",
    "How are you handling unsolicited parenting advice?",
    "What's one thing making you feel confident?",
    "How do you feel about your ability to comfort baby?",
    "What's your strategy for managing new parent stress?",
    "How are you preparing for your partner's emotional needs?",
    "What's one way you'll celebrate becoming a parent?",
    "How do you feel about the upcoming life change?",
    "What's your plan for staying connected as a couple?",
    "How are you handling the final nesting projects?",
    "What's one thing you're grateful for about this journey?",
    "How do you feel about your birth preparation?",
    "What's your biggest excitement for meeting baby?",
];

/**
 * Get the appropriate topic for a cohort based on week and role.
 * - Same topic for everyone in the same cohort/role on the same day
 * - Topics are relevant to their stage of pregnancy
 * - Rotates daily for fresh content
 */
export function getTopicForWeekAndRole(week: number, role: 'partner' | 'pregnant'): string {
    // Determine trimester based on week
    let topics: string[];

    if (role === 'pregnant') {
        if (week <= 12) {
            topics = PREGNANT_TOPICS_FIRST_TRIMESTER;
        } else if (week <= 27) {
            topics = PREGNANT_TOPICS_SECOND_TRIMESTER;
        } else {
            topics = PREGNANT_TOPICS_THIRD_TRIMESTER;
        }
    } else {
        // Partner
        if (week <= 12) {
            topics = PARTNER_TOPICS_FIRST_TRIMESTER;
        } else if (week <= 27) {
            topics = PARTNER_TOPICS_SECOND_TRIMESTER;
        } else {
            topics = PARTNER_TOPICS_THIRD_TRIMESTER;
        }
    }

    // Use date-based hash for consistent daily rotation
    const now = new Date();
    const dateString = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
    let hash = 0;
    for (let i = 0; i < dateString.length; i++) {
        hash = ((hash << 5) - hash) + dateString.charCodeAt(i);
        hash |= 0;
    }

    // Consistent index for everyone in same cohort on same day
    const index = Math.abs(hash % topics.length);
    return topics[index];
}

/**
 * Get topic for week only (backward compatible, uses pregnant role)
 */
export function getTopicForWeek(week: number): string {
    return getTopicForWeekAndRole(week, 'pregnant');
}
